import { useEffect, useState } from "react";
import { CompetitionType } from "../../../../api/competition";
import { useCompetitionContext } from "../hook/competitionContext";
import {
  CompetitionTournamentDropDownBox,
  CompetitionTournamentSelector,
  CompetitionTournamentHeader,
  CompetitionTournamentTypeWrapper,
} from "../styles";
import { getYearList } from "../../../../utils/date";

export interface CompetitionFilterHeaderProp {
  setIsRegionSelect: (v: boolean) => void;
  isRegionSelect: boolean;
}

const CompetitionFilterHeader = ({
  setIsRegionSelect,
  isRegionSelect,
}: CompetitionFilterHeaderProp) => {
  const {
    setPage,
    year,
    setYear,
    month,
    setMonth,
    isSelectedType,
    setRegion,
    setType,
  } = useCompetitionContext();
  const [isYearSelect, setIsYearSelect] = useState(false);
  const [isMonthSelect, setIsMonthSelect] = useState(false);

  const years = getYearList(true);
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const handleSelectType = (type: CompetitionType) => {
    setRegion(null);
    setIsMonthSelect(false);
    setIsRegionSelect(false);
    setIsYearSelect(false);
    setType(type);
  };

  useEffect(() => {
    if (!isRegionSelect) return;
    setIsYearSelect(false);
    setIsMonthSelect(false);
  }, [isRegionSelect]);

  return (
    <CompetitionTournamentHeader>
      <div className="header">
        <div className="title">토너먼트 정보</div>
        <div className="date-box">
          <CompetitionTournamentSelector
            onClick={() => {
              setIsMonthSelect(false);
              setIsRegionSelect(false);
              setIsYearSelect(!isYearSelect);
            }}
          >
            <div className="value">{`${year}년`}</div>
            <img src="/image-web/competition/drop-down.svg" alt="drop-down" />
            {isYearSelect && (
              <CompetitionTournamentDropDownBox>
                {years.map((item, index) => (
                  <div
                    className={`item ${item === year && "active"}`}
                    key={index}
                    onClick={() => {
                      setYear(item);
                      setPage(1);
                    }}
                  >
                    {item}년
                  </div>
                ))}
              </CompetitionTournamentDropDownBox>
            )}
          </CompetitionTournamentSelector>
          <CompetitionTournamentSelector
            onClick={() => {
              setIsYearSelect(false);
              setIsRegionSelect(false);
              setIsMonthSelect(!isMonthSelect);
            }}
          >
            <div className="value">{`${month}월`}</div>
            <img src="/image-web/competition/drop-down.svg" alt="drop-down" />
            {isMonthSelect && (
              <CompetitionTournamentDropDownBox style={{ left: "-30px" }}>
                {months.map((item, index) => (
                  <div
                    className={`item ${item === month && "active"}`}
                    key={index}
                    onClick={() => {
                      setMonth(item);
                      setPage(1);
                    }}
                  >
                    {item}월
                  </div>
                ))}
              </CompetitionTournamentDropDownBox>
            )}
          </CompetitionTournamentSelector>
        </div>
      </div>
      <CompetitionTournamentTypeWrapper>
        <div
          className={`item ${isSelectedType(CompetitionType.DOMESTIC)}`}
          onClick={() => {
            handleSelectType(CompetitionType.DOMESTIC);
            setPage(1);
          }}
        >
          국내 대회
        </div>
        <div
          className={`item ${isSelectedType(CompetitionType.INTERNATIONAL)}`}
          onClick={() => {
            handleSelectType(CompetitionType.INTERNATIONAL);
            setPage(1);
          }}
        >
          해외 대회
        </div>
      </CompetitionTournamentTypeWrapper>
    </CompetitionTournamentHeader>
  );
};
export default CompetitionFilterHeader;
